import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgForward = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_892_19958",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_892_19958)",
		children: /* @__PURE__ */ _jsx("path", { d: "M3.2981 18.75V15C3.2981 13.6872 3.76155 12.5673 4.68847 11.6404C5.61539 10.7135 6.73525 10.25 8.04807 10.25H17.8443L13.9942 6.40002L15.0481 5.34619L20.7019 11L15.0481 16.6538L13.9942 15.6L17.8443 11.75H8.04807C7.14422 11.75 6.37659 12.0657 5.74517 12.6971C5.11375 13.3285 4.79805 14.0962 4.79805 15V18.75H3.2981Z" })
	})]
});
export default SvgForward;
